import {useEffect, useState} from 'react';
import {MemberSettingTypes} from "../types/member/member.setting.types";
import {getMemberSetting} from "../api/memberApi";

export const useMemberSetting = () => {

    //TODO: 선수금 설정 가져오기 hook

    const [memberSetting, setMemberSetting] = useState<MemberSettingTypes>();
    const [memberSettingLoading, setMemberSettingLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getSetting = async () => {
        try {
            setMemberSettingLoading(true);
            setError(null);
            const response = await getMemberSetting();
            if (response.data?.code == "00") {
                setMemberSetting(response.data.data);
            }
        } catch (err) {
            console.error('Failed to fetch getChargeSetting:', err);
            setError('설정을 불러오는데 실패했습니다.');
        } finally {
            setMemberSettingLoading(false);
        }

    };

    useEffect(() => {
        getSetting();
    }, []);

    return {
        memberSetting,
        memberSettingLoading,
        error
    };

};